import { fork } from 'redux-saga/effects';
import { profilesConfigWatcher } from "./profilesSagas";
import { profileCardConfigWatcher } from "./profileCardSagas";
/*
function* watchAndLog() {
    while (true) {
      const action = yield take('*')
      const state = yield select()
  
      console.log('action', action)
      console.log('state after', state,state.Client.user.id);
    }
  }
    // yield fork(watchAndLog);
*/
export default function* Employees() {
    yield fork(profilesConfigWatcher);
    yield fork(profileCardConfigWatcher);
}
